export default __webpack_public_path__ + "static/media/secure.98f218c8.svg";